import React from 'react';
import { Alert, AlertTitle, IconButton, Collapse } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import { ErrorState } from '../../hooks/useErrorHandler';

interface ErrorDisplayProps {
  error: ErrorState | null;
  onClose?: () => void;
  onRetry?: () => void;
  showRetry?: boolean;
  className?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onClose,
  onRetry,
  showRetry = true,
  className = ''
}) => {
  if (!error) return null;

  const getSeverity = (type: ErrorState['type']) => {
    switch (type) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'error';
    }
  };

  return (
    <Collapse in={!!error}>
      <Alert
        severity={getSeverity(error.type)}
        className={`error-display ${className}`}
        action={
          <>
            {showRetry && error.retry && (
              <IconButton
                aria-label="retry"
                color="inherit"
                size="small"
                onClick={error.retry || onRetry}
              >
                <RefreshIcon fontSize="inherit" />
              </IconButton>
            )}
            {onClose && (
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={onClose}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            )}
          </>
        }
        sx={{
          mb: 2,
          '& .MuiAlert-message': {
            width: '100%'
          }
        }}
      >
        <AlertTitle>
          {error.type === 'error' ? 'Error' :
           error.type === 'warning' ? 'Warning' : 'Information'}
          {error.code && ` (${error.code})`}
        </AlertTitle>
        {error.message}
      </Alert>
    </Collapse>
  );
};

export default ErrorDisplay;
